/**
 * Utilities to work with Query String
 * (the original code was published in GitHub in October 2015,
 * here it is simply annotated to make TypeScript happy).
 *
 * https://github.com/RobertoPrevato/jQuery-KingTable/edit/master/source/scripts/shared/data/query.js
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 */

// React router has a "hook" to read query parameters, but it has
// nasty restriction as it can only be used in function components:
// ostentatious and arrogant approach.

const location = window.location;


interface Query {
  [key: string]: string
}


function getAll(): Query {
  const o: { [key: string]: string } = {};
  let i, l, x: string;
  const splitter = /\?|&/;
  let s = location.search.split(splitter);
  const m = location.hash.match(/(\?.+)$/);

  // support query string inside hash (normally it is ignored)
  if (m)
    s = s.concat(m[1].split(splitter));
  for (i = 0, l = s.length; i < l; i++) {
    x = s[i];
    if (!x) continue;
    const [key, value] = x.split(/=/);

    o[key] = decodeURIComponent(value);
  }
  return o;
}


function get(name: string): string {
  return getAll()[name];
}


function write(
  data: { [key: string]: string | boolean | number | undefined }
): string
{
  let key: string;
  let value: string | boolean | number | undefined;
  const parts: string[] = [];

  for (key in data) {
    value = data[key];

    if (value === undefined) {
      continue;
    }

    if (typeof value === "string" && value === "") {
      continue;
    }

    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
  }

  return "?" + parts.join("&");
}


export default {
  getAll,
  get,
  write
};
